module.exports = __webpack_public_path__ + "static/staff-visual-2x-c30f0f56c7081673691050fa82216932.png";